import { identity, pickBy } from 'lodash';

function createQueryParams(params: Record<string, string>): string {
  const queryParams = new URLSearchParams(pickBy(params, identity));
  return queryParams.toString();
}
export default createQueryParams;
